import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center bg-background-50 overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20artistic%20illustration%20collage%20of%20various%20comic%20characters%20in%20dynamic%20poses%2C%20warm%20orange%20and%20golden%20lighting%2C%20soft%20watercolor%20abstract%20background%20with%20floating%20sparkles%2C%20manga%20aesthetic%2C%20dreamy%20atmosphere%2C%20clean%20edges&width=1800&height=800&seq=hero-bg-2026&orientation=landscape"
          alt="韩漫之家 - 免费韩国漫画在线阅读"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/55 via-foreground-950/35 to-background-50"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center pt-20 pb-16">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading text-background-50 leading-tight">
            免费韩漫大全
          </h1>
          <p className="mt-5 text-base md:text-lg text-background-100/80 max-w-xl mx-auto leading-relaxed">
            韩漫之家汇集海量免费韩漫，支持韩国漫画下拉式在线阅读。从经典到新作，热血、恋爱、奇幻、悬疑、搞笑一应俱全，满足您对韩漫的所有期待与热爱。
          </p>
          <div className="flex items-center justify-center gap-4 mt-8">
            <Link
              to="/category/rexue"
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-medium text-sm rounded-full hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              热门漫画
              <i className="ri-arrow-right-line"></i>
            </Link>
            <Link
              to="/about"
              className="inline-flex items-center gap-2 px-6 py-3 border border-background-100/40 text-background-50 font-medium text-sm rounded-full hover:bg-background-50/10 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              关于我们
            </Link>
          </div>

          <div className="mt-12 flex items-center justify-center gap-8 text-background-100/70">
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-bold text-background-50">10,000+</p>
              <p className="text-xs mt-1 text-background-100/60">漫画作品</p>
            </div>
            <div className="w-px h-10 bg-background-100/20"></div>
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-bold text-background-50">200万+</p>
              <p className="text-xs mt-1 text-background-100/60">日活跃用户</p>
            </div>
            <div className="w-px h-10 bg-background-100/20"></div>
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-bold text-background-50">50亿+</p>
              <p className="text-xs mt-1 text-background-100/60">累计阅读量</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}